<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vs-tabs>
        <vs-tab label="ข้อมูลการชำระเงิน">
          <PaymentInfoTab></PaymentInfoTab>
        </vs-tab>
        <vs-tab label="ข้อมูลการชำระเงิน (ค่าใช้จ่าย)">
          <PaymentExpenseInfoTab></PaymentExpenseInfoTab>
        </vs-tab>
        <vs-tab label="ข้อมูลกำหนดการนัดชำระเงิน">
          <PaymentScheduleTab></PaymentScheduleTab>
        </vs-tab>
      </vs-tabs>
    </div>
  </div>
</template>

<script>
import PaymentInfoTab
  from "@/views/pages/Accounting/Contract/Detail/Components/PaymentInfoAndPaymentExpenseInfoTab/components/PaymentInfoTab/index.vue";
import PaymentExpenseInfoTab
  from "@/views/pages/Accounting/Contract/Detail/Components/PaymentInfoAndPaymentExpenseInfoTab/components/PaymentExpenseInfoTab/index.vue";
import PaymentScheduleTab
  from "@/views/pages/Accounting/Contract/Detail/Components/PaymentInfoAndPaymentExpenseInfoTab/components/PaymentScheduleTab/index.vue";

export default {
  name: 'FeeInfoAndExpenseInfoTab',
  components: {
    PaymentInfoTab,
    PaymentExpenseInfoTab,
    PaymentScheduleTab,
  },
}
</script>

<style scoped>
.vx-row {
  margin-bottom: 15px;
}
</style>
